import React from 'react'
import {
  ActivityIndicator,
  TouchableOpacity,
  StyleSheet,
  View,
} from 'react-native'
import { Query, Mutation } from 'react-apollo'
import Modal from 'modal-enhanced-react-native-web'
import { colors, fonts, hexToRgba } from '../../../functions'
import { DimensionsConsumer } from '../../../lib'
import { CREATE_TICKET_OPTION } from '../../../gql'
import {
  BaseText,
  FormButton,
  HoverableText,
  PhotoCardSquare,
  PhotoUploader,
  PhotoPlaceholder,
  ScrollColumn,
  MCIcon,
} from '../../../components'

const WIDTH = 400
const PHOTOS_HEIGHT = 450

const s = StyleSheet.create({
  trigger: {
    paddingRight: 15,
  },
  modal: {
    display: 'flex',
    flexDirection: 'column',
    width: WIDTH,
    alignSelf: 'center',
    backgroundColor: colors.primary3,
    paddingHorizontal: 11,
    paddingVertical: 13,
    borderRadius: 20,
  },
  modalCloseButton: {
    position: 'absolute',
    zIndex: 1,
  },
  modalMessageContainer: {
    display: 'flex',
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 7,
    marginBottom: 23,
  },
  modalControls: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  buttonsContainer: {
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
    marginBottom: 23,
    alignItems: 'center',
    justifyContent: 'center',
  },
  sectionHeader: {
    display: 'flex',
    flexDirection: 'column',
    alignSelf: 'stretch',
    paddingTop: 10,
    alignItems: 'center',
    justifyContent: 'center',
  },
  rowCenter: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  row: {
    display: 'flex',
    alignSelf: 'stretch',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'baseline',
    paddingLeft: 30,
  },
  lineBreak: {
    display: 'flex',
    alignSelf: 'stretch',
    backgroundColor: hexToRgba(colors.secondary1, 0.5),
    height: 2,
    minHeight: 2,
    maxHeight: 2,
    marginTop: 7,
    marginBottom: 14,
  },
  text: {
    fontFamily: fonts.regular,
    fontSize: '13px',
    lineHeight: '18px',
    color: colors.secondary2,
    zIndex: 6,
  },
})

const SectionTitle = props => (
  <BaseText
    fs={20}
    lh={27}
    mb={7}
    weight={'semibold'}
    color={'secondary3'}
    {...props}
  />
)

export class ExitModal extends React.Component {
  state = {
    modalIsVisible: false,
  }

  _handleExitPrompt = async () => {
    const { form, history } = this.props

    if (
      form.getFormikBag().dirty &&
      !Object.keys(await form.validateForm(form.state.values)).length
    ) {
      this.setState({ modalIsVisible: true })
    } else {
      history.goBack()
    }
  }

  _handleClose = () => {
    this.setState({ modalIsVisible: false })
  }

  _handleSaveAndExit = async () => {
    return await this.props.form.submitForm()
  }

  _handleEixtWithoutSaving = () => {
    this.props.history.goBack()
  }

  render() {
    const { saveBeforeClosing } = this.props
    const { modalIsVisible } = this.state

    return (
      <DimensionsConsumer>
        {({ width, height }) => {
          const isSmall = width < 673 // 653 + 10 px on each side
          const modalWidth = width - 20

          return (
            <Mutation mutation={CREATE_TICKET_OPTION}>
              {(createTicketOption, { error, loading }) => (
                <React.Fragment>
                  <TouchableOpacity
                    activeOpacity={0.7}
                    onPress={this._handleExitPrompt}
                    style={s.trigger}
                  >
                    <MCIcon name="close" size={24} color={colors.white} />
                  </TouchableOpacity>

                  <Modal
                    isVisible={modalIsVisible}
                    onBackdropPress={() =>
                      this.setState({ modalIsVisible: false })
                    }
                  >
                    <View
                      style={[
                        s.modal,
                        isSmall && { width: modalWidth, paddingRight: 0 },
                      ]}
                    >
                      <View style={s.modalCloseButton}>
                        <TouchableOpacity
                          activeOpacity={0.7}
                          onPress={this._handleClose}
                        >
                          <MCIcon name="close" size={24} color={colors.white} />
                        </TouchableOpacity>
                      </View>
                      <View style={s.modalMessageContainer}>
                        <View style={s.sectionHeader}>
                          <BaseText
                            fs={20}
                            lh={27}
                            weight={'light'}
                            children={`Save & Exit Ticket?`}
                          />
                        </View>
                      </View>
                      <View style={s.modalControls}>
                        <View style={s.buttonsContainer}>
                          <FormButton
                            text={'Exit Without Saving'}
                            textColor={colors.pink}
                            handlePress={this._handleEixtWithoutSaving}
                          />
                          <FormButton
                            text={'Save & Exit'}
                            outerStyle={{ marginRight: 0 }}
                            textColor={colors.teal}
                            handlePress={this._handleSaveAndExit}
                          />
                        </View>
                      </View>
                    </View>
                  </Modal>
                </React.Fragment>
              )}
            </Mutation>
          )
        }}
      </DimensionsConsumer>
    )
  }
}
